import React from 'react';
import styles from 'components/loaders/FullPageLoader.module.css';
import SimpleLoader, { ISimpleLoaderProps } from 'components/loaders/SimpleLoader';

const FullPageLoader: React.FunctionComponent<ISimpleLoaderProps> = props => {
  return (
    <div className={styles.fullSizeLoader}>
      <div className={styles.fullScreen}>
        <SimpleLoader {...props} />
      </div>
    </div>
  );
};

export default FullPageLoader;
